import { MainRoute } from 'src/navigations/Routes/MainRoute';
import { ActionOutboxEntityType } from 'src/WebApiController';

import {
  StopwatchLoggingEventName,
  StopwatchLoggingId,
} from './StopwatchLoggingContext.types';

export const getStopwatchLoggingId = (mainRoute: MainRoute) => {
  switch (mainRoute) {
    case MainRoute.Inventory:
      return StopwatchLoggingId.InventoryPortfolioPage;
    case MainRoute.InventoryEvent:
      return StopwatchLoggingId.InventoryEventPage;
    case MainRoute.InventorySearch:
    case MainRoute.InventorySearchV2:
      return StopwatchLoggingId.InventorySearchPage;
    case MainRoute.Sales:
      return StopwatchLoggingId.SalePortfolioPage;
    case MainRoute.SalesEvent:
      return StopwatchLoggingId.SaleEventPage;
    case MainRoute.SalesSearch:
    case MainRoute.SalesSearchV2:
      return StopwatchLoggingId.SaleSearchPage;
    case MainRoute.Purchases:
      return StopwatchLoggingId.PurchasePortfolioPage;
    case MainRoute.PurchasesEvent:
      return StopwatchLoggingId.PurchaseEventPage;
    case MainRoute.PurchaseSearch:
    case MainRoute.PurchaseSearchV2:
      return StopwatchLoggingId.PurchaseSearchPage;
    default:
      return 'Custom Stopwatch: ' + mainRoute;
  }
};

export const getPosEntityStopwatchLoggingId = (
  actualEntityType: ActionOutboxEntityType
) => {
  switch (actualEntityType) {
    case ActionOutboxEntityType.Listing:
      return StopwatchLoggingId.InventoryActivityPosEntityModal;
    case ActionOutboxEntityType.Purchase:
      return StopwatchLoggingId.PurchaseActivityPosEntityModal;
    case ActionOutboxEntityType.Sale:
      return StopwatchLoggingId.SaleActivityPosEntityModal;
    default:
      return 'Custom Stopwatch: ' + actualEntityType;
  }
};

export const getStopwatchGapsForCatalogPageLoad = (
  isEventPage: boolean,
  hasNoMetrics: boolean
) => {
  if (hasNoMetrics) {
    return [
      StopwatchLoggingEventName.LogStart,
      StopwatchLoggingEventName.EventInfoLoad,
    ];
  }

  return isEventPage
    ? [
        StopwatchLoggingEventName.LogStart,
        StopwatchLoggingEventName.EventInfoLoad,
        StopwatchLoggingEventName.EventEntitiesLoad,
      ]
    : [
        StopwatchLoggingEventName.LogStart,
        StopwatchLoggingEventName.EventInfoLoad,
        StopwatchLoggingEventName.EventMetricsLoad,
      ];
};

export const getStopwatchGapsForActivePosEntityPageLoad = (
  entityType: ActionOutboxEntityType
) => {
  if (entityType === ActionOutboxEntityType.Sale) {
    return [
      StopwatchLoggingEventName.LogStart,
      StopwatchLoggingEventName.EntityLoad,
      StopwatchLoggingEventName.EntityDataLoad,
    ];
  }
  return [
    StopwatchLoggingEventName.LogStart,
    StopwatchLoggingEventName.EntityLoad,
  ];
};
